import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    RemoveAccountParent as RemoveAccountParentMutation,
    RemoveAccountParentVariables as RemoveAccountParentMutationVariables,
} from 'nutshell-graphql-types';

import REMOVE_ACCOUNT_PARENT from '../mutations/remove-account-parent.graphql';

export const useRemoveAccountParent = (): {
    removeAccountParent: (input: {accountId: string}) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [setParent, {loading, error}] = useMutation<
        RemoveAccountParentMutation,
        RemoveAccountParentMutationVariables
    >(REMOVE_ACCOUNT_PARENT);

    return {
        removeAccountParent: (input: {accountId: string}) => {
            const {accountId} = input;

            return setParent({
                variables: {
                    input: {
                        accountId,
                    },
                },
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
